<stages-card
	#card
	[toolbarId]="toolbarId"
	[toolbarItems]="toolbarItems"
	[menuId]="menuId"
	[menuItems]="menuItems"
	[menuNoCollapse]="menuNoCollapse"
>
	@if (tabDefs.length === 1) {
		<h5 [translate]="tabDefs[0].translate!"></h5>
	}
	@if (tabDefs.length !== 1) {
		<header class="contains-scrollable-tabs">
			<stages-tabs [activeTabName]="getActiveTabName()!">
				@for (tabDef of tabDefs; track getTabId($index, tabDef)) {
					<stages-tab-no-route (activate)="onActivate(tabDef)" [active]="tabDef.active">
						<h5 [translate]="tabDef.translate!"></h5>
					</stages-tab-no-route>
				}
			</stages-tabs>
		</header>
	}

	@for (tabDef of tabDefs; track getTabId($index, tabDef)) {
		@if (tabDef.active) {
			<stages-tab-content-dynamic class="panel" [type]="tabDef" />
		}
	}
	@if (sequenceOptions && card.expanded) {
		<stages-add-sequence [sequences]="sequenceOptions" />
	}
</stages-card>
